import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import TargetSection from './components/TargetSection';
import GallerySection from './components/GallerySection';
import ContactSection from './components/ContactSection';
import CtaSection from './components/CtaSection';

const Home = () => (
  <>
    <title>Ev & Co Design Abidjan | Agence de Décoration Haut de Gamme Côte d'Ivoire</title>
    <meta name="description" content="Agence de décoration haut de gamme à Abidjan depuis 2019. Décoration événementielle, aménagement intérieur, création 3D pour particuliers et entreprises en Côte d'Ivoire." />
    <meta name="keywords" content="décoration Abidjan, agence design Côte d'Ivoire, Ev Co Design, décoration haut de gamme Abidjan" />
    <link rel="canonical" href="https://evcodesign-ci.com/" />
    <meta property="og:title" content="Ev & Co Design Abidjan | Agence de Décoration Haut de Gamme Côte d'Ivoire" />
    <meta property="og:description" content="Agence de décoration événementielle, d'intérieur et de création 3D à Abidjan. Donnez vie à vos espaces et événements avec Ev & Co Design." />
    <main className="font-sans bg-brand-beige min-h-screen">
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <TargetSection />
      <GallerySection />
      <CtaSection />
      <ContactSection />
      <Footer />
    </main>
  </>
);

export default Home;
